import { PERMISSIONS } from '../constants'

export const defaultPermissions = [PERMISSIONS.SEARCH, PERMISSIONS.SUBMIT]
export const permissions = (state = defaultPermissions, action) => {
  switch (action.type) {
    case 'SET_PERMISSIONS':
      return action.permissions
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/permission.js